/* eslint-disable react/require-default-props */
import React from 'react';

import { Form, Alert } from 'antd';
import Select from 'components/forms/Select';
import Button from 'components/forms/Button';
import Input from 'components/forms/Input';

const SaveOverwriteForm = ({
    formRef,
    activeSave = null,
    savesList,
    onRefreshSavesList,
    selectedSaveID = null,
    onChangeSelectedSaveID,
    onChangeMode,
}) => {
    const onSelectSave = (saveID) => {
        onChangeSelectedSaveID(saveID);
        const selectedSave = savesList.data.find((row) => row.id === saveID);
        formRef.setFieldsValue({
            name: selectedSave.name,
            description: selectedSave.description,
        });
    };

    return (
        <Form
            form={formRef}
            initialValues={{
                name: activeSave && activeSave.name,
                description: activeSave && activeSave.description,
                selectedSaveID,
            }}
            labelCol={{
                span: 5,
            }}
            wrapperCol={{
                span: 15,
            }}
        >
            {savesList.error && (
                <Alert
                    style={{ marginBottom: '1.5em' }}
                    type="error"
                    message="Something went wrong"
                    description={
                        <>
                            Sorry, we couldn't load the saves. Please try again later.
                            <Button
                                name="retryFetchButton"
                                onClick={onRefreshSavesList}
                                size="small"
                                style={{ marginLeft: '0.8em' }}
                            >
                                Retry
                            </Button>
                        </>
                    }
                    showIcon
                />
            )}
            <Form.Item
                label="Select a save"
                name="selectedSaveID"
                rules={[
                    {
                        required: true,
                        message: 'Please select a save to update',
                    },
                ]}
            >
                <Select
                    value={selectedSaveID}
                    onChange={onSelectSave}
                    loading={savesList.fetching}
                    options={(savesList.data || []).map((save) => ({
                        label: save.name,
                        value: save.id,
                    }))}
                    style={{ width: '100%' }}
                />
            </Form.Item>
            {selectedSaveID && (
                <>
                    <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Description" name="description">
                        <Input.TextArea />
                    </Form.Item>
                </>
            )}
            <Button block type="link" onClick={onChangeMode}>
                I want to create a new save instead
            </Button>
        </Form>
    );
};

export default SaveOverwriteForm;
